export default [
  {
    path: '/halal-documentary-requirements',
    name: 'halal-documentary-requirements',
    component: () => import(
      '@/views/halal/documentary-requirements/DocumentaryRequirements.vue'
    ),
    meta: {
      title: 'Documentary Requirements Halal',
      requiresAuth: true,
      action: 'browes',
      resource: 'Documentary Requirements Halal',
      pageTitle: 'Halal',
      breadcrumb: [
        {
          text: 'Documentary Requirements Halal',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/halal-documentary-requirements/add',
    name: 'add-halal-documentary-requirements',
    component: () => import(
      '@/views/halal/documentary-requirements/control-documentary-requirements/AddEditDocumentaryRequirements.vue'
    ),
    meta: {
      title: 'Add Documentary Requirements Halal',
      requiresAuth: true,
      action: 'create',
      resource: 'Documentary Requirements Halal',
      pageTitle: 'Halal',
      breadcrumb: [
        {
          text: 'Documentary Requirements Halal',
          to: '/halal-documentary-requirements',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/halal-documentary-requirements/edit/:id',
    name: 'edit-halal-documentary-requirements',
    component: () => import(
      '@/views/halal/documentary-requirements/control-documentary-requirements/AddEditDocumentaryRequirements.vue'
    ),
    meta: {
      title: 'Edit Documentary Requirements Halal',
      requiresAuth: true,
      pageTitle: 'Halal',
      breadcrumb: [
        {
          text: 'Documentary Requirements Halal',
          to: '/halal-documentary-requirements',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
